"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.UnitNotEnoughError = exports.InvalidNumberError = void 0;
class InvalidNumberError extends Error {
}
exports.InvalidNumberError = InvalidNumberError;
class UnitNotEnoughError extends Error {
}
exports.UnitNotEnoughError = UnitNotEnoughError;
//# sourceMappingURL=types.js.map